import _ from 'lodash';
import React, { PropTypes } from 'react';
import OptionTool from './OptionTool';
import { icon } from './../../../../icons/icons';

const ChoiceTools = (props) => {
    const { widget, actions } = props;

    const goBack = () => {
        actions.setWidgetTools('general');
    };

    const onChange = (optionId, e) => {
        actions.setChoiceWidgetValue(optionId, widget.id, e.target.value);
    };

    const addRadio = () => {
        actions.addChoiceOption(widget.id);
    };

    const deleteRadio = (optionId) => {
        actions.deleteChoiceOption(widget.id, optionId);
    };

    return (
        <div className="option">
            <h3 className="option__header">{widget.type} Edit</h3>
            <div className="option__back" onClick={goBack} title="Back">{icon.backArrow()}</div>

            <div>
                {_.map(widget.options, (option) =>
                    <OptionTool
                        key={option.id}
                        option={option}
                        optionsList={widget.optionsList}
                        deleteRadio={deleteRadio.bind(this, option.id)}
                        onValueChange={onChange.bind(this, option.id)}
                    />
                )}
                <div className="btn -full" onClick={addRadio}>Add Option</div>
            </div>
        </div>
    );
};

ChoiceTools.propTypes = {
    widget: PropTypes.object.isRequired,
    actions: PropTypes.object.isRequired,
};

export default ChoiceTools;



// WEBPACK FOOTER //
// ./src/_app/quick_response/components/Tools/Widgets/Choice/ChoiceTools.jsx